import { useContext } from 'react';
import { OfficeTutorialContext } from './Context';

export const useOfficeTutorial = () => useContext(OfficeTutorialContext);
